type CategoryNode = {
  slug?: string | null;
  name?: string | null;
  subCategories?: CategoryNode[] | null;
};

/**
 * Builds a `slug -> display name` lookup from a hierarchicalCategories API response
 * (parents and their subCategories), used to render category names sourced from the API
 * instead of the local `categoryDisplayNames` map.
 */
export const buildCategoryNames = (categories?: CategoryNode[] | null): Record<string, string> => {
  const names: Record<string, string> = {};
  categories?.forEach((parent) => {
    if (parent.slug && parent.name) names[parent.slug] = parent.name;
    parent.subCategories?.forEach((sub) => {
      if (sub.slug && sub.name) names[sub.slug] = sub.name;
    });
  });
  return names;
};
